module.exports = __webpack_public_path__ + "static/media/home-header-422x349.7d428af5.svg";